/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostRecruitmentCheckPhoneMutationRequest,
  PostRecruitmentCheckPhoneMutationResponse,
  PostRecruitmentCheckPhone400,
} from '../entities/PostRecruitmentCheckPhone'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postRecruitmentCheckPhone } from '../api/postRecruitmentCheckPhone'
import { useMutation } from '@tanstack/react-query'

export const postRecruitmentCheckPhoneMutationKey = () => [{ url: '/recruitment/check-phone' }] as const

export type PostRecruitmentCheckPhoneMutationKey = ReturnType<typeof postRecruitmentCheckPhoneMutationKey>

/**
 * @description Проверка номера телефона
 * @summary Проверка номера телефона
 * {@link /recruitment/check-phone}
 */
export function usePostRecruitmentCheckPhone<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostRecruitmentCheckPhoneMutationResponse,
      ResponseErrorConfig<PostRecruitmentCheckPhone400>,
      { data: PostRecruitmentCheckPhoneMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<PostRecruitmentCheckPhoneMutationRequest>> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postRecruitmentCheckPhoneMutationKey()

  return useMutation<
    PostRecruitmentCheckPhoneMutationResponse,
    ResponseErrorConfig<PostRecruitmentCheckPhone400>,
    { data: PostRecruitmentCheckPhoneMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return postRecruitmentCheckPhone(data, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}